import { createContext, useContext } from 'react';

// Lets RowActionsCell know whether its table currently has any row
// checkbox-selected, without threading that state through every tab
// factory's own `columns` useMemo (columns are built once per factory,
// outside SelectableTabTable, which is the thing that actually owns
// `selectedIds`). SelectableTabTable provides this; a row rendered via
// plain PipelineDataTable (no selection at all, e.g. scorableTabFactory's
// tabs) never sits inside a provider, so the default below — no
// selection — is what those always see.
const SelectionContext = createContext({ hasSelection: false });

export const SelectionProvider = SelectionContext.Provider;

export const useSelectionContext = () => useContext(SelectionContext);
